/**
 * Breadcrumb trails for authenticated app routes. Last item has `to: null` (current page).
 */
const TRAILS = {
  "/": [{ label: "Dashboard", to: null }],
  "/access/users": [
    { label: "Dashboard", to: "/" },
    { label: "Access", to: "/access/users" },
    { label: "Users", to: null },
  ],
  "/access/roles": [
    { label: "Dashboard", to: "/" },
    { label: "Access", to: "/access/users" },
    { label: "Roles", to: null },
  ],
  "/projects": [
    { label: "Dashboard", to: "/" },
    { label: "Projects", to: null },
  ],
  "/vendors": [
    { label: "Dashboard", to: "/" },
    { label: "Vendors", to: null },
  ],
  "/expenses": [
    { label: "Dashboard", to: "/" },
    { label: "Expenses", to: null },
  ],
  "/projects/create": [
    { label: "Dashboard", to: "/" },
    { label: "Projects", to: "/projects" },
    { label: "Create Project", to: null },
  ],
  "/projects/archived": [
    { label: "Dashboard", to: "/" },
    { label: "Projects", to: "/projects" },
    { label: "Archived Projects", to: null },
  ],
  "/settings": [
    { label: "Dashboard", to: "/" },
    { label: "Settings", to: null },
  ],
  "/about": [
    { label: "Dashboard", to: "/" },
    { label: "About", to: null },
  ],
};

function humanizeSegment(segment) {
  return segment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Fallback: Dashboard + path segments when no explicit trail exists (e.g. 404-like paths).
 */
function fallbackTrail(normalizedPath) {
  if (normalizedPath === "/") {
    return TRAILS["/"];
  }
  const segments = normalizedPath.replace(/^\//, "").split("/").filter(Boolean);
  const crumbs = [{ label: "Dashboard", to: "/" }];
  let acc = "";
  segments.forEach((seg, i) => {
    acc += `/${seg}`;
    const last = i === segments.length - 1;
    crumbs.push({
      label: humanizeSegment(seg),
      to: last ? null : acc,
    });
  });
  return crumbs;
}

export function getBreadcrumbs(pathname) {
  const normalized = pathname.replace(/\/$/, "") || "/";
  if (TRAILS[normalized]) {
    return TRAILS[normalized];
  }
  return fallbackTrail(normalized);
}
